import BaseModel from "./BaseModel";
import { InAppMessagePresentation } from "./InAppMessage";

export default class InAppMessageListItem extends BaseModel {
  id: number;
  toEmail: string;
  title: string;
  presentation: InAppMessagePresentation;
  showPopup: boolean;
  sentAt: Date;
  viewedAt?: Date;
  dismissedAt?: Date;
  expiresAt?: Date;

  static __dates = ["sentAt", "viewedAt", "dismissedAt", "expiresAt"];

  constructor(data: any) {
    super(data, InAppMessageListItem.__dates);
    this.id = data.id;
    this.toEmail = data.toEmail;
    this.title = data.title;
    this.presentation = data.presentation;
    this.showPopup = data.showPopup;
    this.sentAt = this.__get('sentAt');
    this.viewedAt = this.__get('viewedAt');
    this.dismissedAt = this.__get('dismissedAt');
    this.expiresAt = this.__get('expiresAt');
  }
}
